import { useQuery } from "@tanstack/react-query";
import { getPlannerTokenSharing, getTenantInfo } from "../../sevices/apiSystemSettings";
import { localStorageInstance } from "../localStorage";

export function useTenant() {
  const {
    isLoading,
    data,
    error,
    isError,
  } = useQuery({
    queryKey: ["tenant-details"],
    queryFn: getTenantInfo,
  });

  localStorageInstance.setItem({
    key: "planner_token_sharing_enabled",
    value: data?.data?.data?.responseData?.planner_token_sharing_enabled,
  });

  return { isLoading, error, data, isError };
}




export function usePlannerTokenSharing(domain) {
  const {
    isLoading,
    data,
    error,
    isError,
  } = useQuery({
    queryKey: ["planner-token-sharing"],
    queryFn: () => getPlannerTokenSharing(domain),
    enabled: Boolean(domain),
  });

  localStorageInstance.setItem({
    key: "planner_token_sharing_enabled",
    value: data?.data?.enabled,
  });

  return { isLoading, error, data, isError };
}